.base {
	display: flex;
	flex-wrap: wrap;
	width: fit-content;

	&[data-orientation='horizontal'] {
		flex-direction: row;
		align-items: center;
	}

	&[data-orientation='vertical'] {
		flex-direction: column;
		align-items: start;
	}
}

.basic {
	gap: var(--lp-spacing-400);
}

.compact {
	gap: var(--lp-spacing-200);
}

.large {
	gap: var(--lp-spacing-600);
}
